import React from 'react'
import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'
import { isMysteryComboBetType, isMysterySelection } from '@mobi/betslip/helpers/typeGuards'
import type { MysteryDetails, MysterySelection } from '@mobi/betslip/types'
import { Grid, GridCell } from '@mobi/component-library/Legacy/Grid'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { spacing } from '@mobi/component-library/Foundations'
import { Money } from '@core/Components/Text/Money'
import {
  AmountStyled,
  FlexiDisplayStyled,
} from '@core/Areas/Quickbet/Components/BetInvestment/Components/FlexiDisplay/FlexiDisplay.styles'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { MysteryNoveltySelection } from './MysteryNoveltySelection'
import { MysteryComboSelection } from './MysteryComboSelection'

interface MysteryDisplaySelectionProps {
  selection: MysterySelection
  details: MysteryDetails
}

export const MysteryDisplaySelections = ({ selection, details }: MysteryDisplaySelectionProps) => {
  if (!isMysterySelection(selection)) return null
  if (!selection.bets) return null

  const bet = selection.bets[0]
  const isCombo = isMysteryComboBetType(selection)

  return (
    <Flex flexDirection='column' gap={spacing.smx1}>
      {isCombo ? (
        <MysteryComboSelection selection={selection} />
      ) : isMysteryNoveltyBetType(selection) ? (
        <MysteryNoveltySelection selection={selection} />
      ) : (
        <SelectionInfo
          text={
            <span data-tid-mystery-selection=''>
              Mystery Selections <br />
              {bet.betLines[0].selections}
            </span>
          }
        />
      )}

      {!isCombo && (
        <MysteryBetInvestmentStyled>
          <Grid padding='0.4rem'>
            <GridCell width='50%'>
              <FlexiDisplayStyled isActive={false}>
                <span>Spend</span>{' '}
                <AmountStyled amount={1}>
                  <Money amount={details.investmentWin} />
                </AmountStyled>
              </FlexiDisplayStyled>
            </GridCell>
            <GridCell width='50%'>
              <FlexiDisplayStyled isActive={false}>
                <span>Flexi</span> <AmountStyled amount={1}>{bet.divXAnnotations}</AmountStyled>
              </FlexiDisplayStyled>
            </GridCell>
          </Grid>
        </MysteryBetInvestmentStyled>
      )}
    </Flex>
  )
}

// =============
// Local Helpers
// =============

function isMysteryNoveltyBetType(selection: MysterySelection): boolean {
  return selection.bets ? selection.productCode.toLowerCase() !== 'combo' : false
}

// ======
// Styles
// ======

const MysteryBetInvestmentStyled = styled.div({
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  marginTop: '1rem',
  position: 'relative',
})
